import { AutogenLayoutFuelGLControlList } from "./autogen/AutogenLayoutFuelGLControlList";

export class FuelGLControlList extends AutogenLayoutFuelGLControlList {
}
